export const aboutData = {
    title: "Who I am",
    description1: "My name's Mohamed, a web developer and software engineer based in Ingolstadt, Germany.",
    description2: "At ASAP GmbH, I build interactive analysis tools for electric vehicles using Python and Visual Basic Script. I earned my B.S. in Mechatronics from TU Ilmenau, where I contributed to award-winning projects like a smart T-shirt for tracking trunk kinematics. In addition, I work on freelance projects in full-stack web development and AI, always exploring new technologies.",
    image: 1
}

 